import React from 'react'
import { BetInfo } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetStatus } from '@core/Areas/KambiSports/helpers/getKambiCouponBetStatus'
import {
  KambiHistoryCouponDisplayContext,
  type KambiHistoryCouponDisplayContextType,
} from '@core/Areas/KambiSports/Components/BetHistory/context'
import { BetSelectionContainer } from '../Common/BetSelectionContainer'

export const KambiBetSelectionDisplay: React.FC<{
  coupon: BetLoopKambiShareCoupon
  handleDisableCopyBet?(): void
  isForExternalShare?: boolean
}> = ({ coupon, handleDisableCopyBet, isForExternalShare = false }) => {
  const status = getKambiCouponBetStatus(coupon.bets[0]?.betStatus)
  const betStatus = status === 'Won' ? 'win' : status === 'No Payout' ? 'loss' : null

  const contextValue = React.useMemo<KambiHistoryCouponDisplayContextType>(() => {
    return isForExternalShare
      ? { type: 'external-share' }
      : { type: 'betloop', utils: { handleDisableCopyBet } }
  }, [isForExternalShare, handleDisableCopyBet])

  return (
    <KambiHistoryCouponDisplayContext.Provider value={contextValue}>
      <BetSelectionContainer.Container displayStatus={betStatus}>
        <BetSelectionContainer.Inner>
          <BetInfo historyCoupon={coupon} />
        </BetSelectionContainer.Inner>
      </BetSelectionContainer.Container>
    </KambiHistoryCouponDisplayContext.Provider>
  )
}
